// extracted by mini-css-extract-plugin
module.exports = {"cookie_Consent":"CookieBannerV2_cookie_Consent__1Eol1","cookie_Text":"CookieBannerV2_cookie_Text__1lvYY"};